import React from "react";
import NewsletterCommon from "src/modules/newsletter/newsletter.component.common";
import CTAButton from "src/components/ctabutton";
import { ModuleHeadV2 } from "src/components/moduleHead/moduleHead.v2";

export default class NewsletterSideBySide extends NewsletterCommon {
  render() {
    const {
      email,
      setEmailValue,
      description,
      inputPlaceholder = "Email address",
      title,
      textPosition,
      ctaButton,
      body_color,
      title_color,
      alignment,
    } = this.props;

    const textOrder = textPosition === "left" ? "lg:order-2" : "";

    return (
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8" style={this.style}>
        <div className={`max-w-xl lg:col-span-7 ${textOrder}`}>
          <ModuleHeadV2
            title={title}
            color_title={title_color}
            description={description}
            color_description={body_color}
            alignment={alignment === "center" ? "text-center" : alignment === "right" ? "text-right" : "text-left"}
            align_lists
            subtitle=""
          />
        </div>
        <form ref={this.formRef} onSubmit={this.formSubmit} className="w-full max-w-md lg:col-span-5 lg:pt-2">
          <div className="flex gap-x-4">
            <label htmlFor="email-address" className="sr-only">
              Email address
            </label>
            <input
              value={email}
              onChange={(e) => setEmailValue(e.target.value)}
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              className={`min-w-0 flex-auto rounded-md border-0 px-3.5 py-2 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${this.email_focus_color_classname}`}
              placeholder={inputPlaceholder}
            />
            <CTAButton {...ctaButton} onClick={(e) => this.onCTAclick(e)} />
          </div>

          {this.renderFeedback()}
          {this.renderDisclaimer()}
        </form>
      </div>
    )
  }
}
